var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('aplayer',{attrs:{"autoplay":"","music":_vm.firstSong,"list":_vm.allSongs,"shuffle":true,"repeat":_vm.repeat-_vm.all}}),_c('TimelineGallery')],1)}
var staticRenderFns = []

export { render, staticRenderFns }